export default __webpack_public_path__ + "static/media/image-ph-health-alarm-w.08b174f8.webp";